import { render } from "./TaskDetails.vue?vue&type=template&id=e67b1950&scoped=true"
import script from "./TaskDetails.vue?vue&type=script&lang=js"
export * from "./TaskDetails.vue?vue&type=script&lang=js"

import "./TaskDetails.vue?vue&type=style&index=0&id=e67b1950&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e67b1950"

export default script